import Vue from 'vue'
import Laraform from '@laraform/laraform'

import FormPage from './components/forms/FormPage'
import FormLoader from './components/forms/FormLoader'
import FormComponent from './components/forms/FormComponent'

Vue.use(Laraform)

Vue.component('form-page', FormPage)
Vue.component('form-loader', FormLoader)
Vue.component('form-component', FormComponent)

import Sentiment from './components/forms/elements/Sentiment'
Laraform.element('sentiment', Sentiment)
import Signature from './components/forms/elements/Signature'
Laraform.element('signature', Signature)
import PurchaseOrders from './components/forms/elements/PurchaseOrders'
Laraform.element('purchase_orders', PurchaseOrders)
import PlantUsed from './components/forms/elements/PlantUsed'
Laraform.element('plant_used', PlantUsed)
import AsyncSelect from './components/forms/elements/AsyncSelect'
Laraform.element('async-select', AsyncSelect)
import AsyncMultiselect from './components/forms/elements/AsyncMultiselect'
Laraform.element('async-multiselect', AsyncMultiselect)
